import Box from '@mui/material/Box'
import Radio from '@mui/material/Radio'
import Button from '@mui/material/Button'
import Popover from '@mui/material/Popover'
import { Grid, Modal } from '@mui/material'
import { useTranslation } from 'react-i18next'
import FormLabel from '@mui/material/FormLabel'
import RadioGroup from '@mui/material/RadioGroup'
import Typography from '@mui/material/Typography'
import FormControl from '@mui/material/FormControl'
import SettingsIcon from '@mui/icons-material/Settings'
import FormControlLabel from '@mui/material/FormControlLabel'
import { ChangeEvent, MouseEvent, useEffect, useState } from 'react'

import { setBaseUrl } from '../helpers/http'
import { Environment } from '../enums/enums'
import { DEFAULT_ENV_KEY } from '../constants'
import { isProduction } from '../helpers/common'
import { setLocalStorage } from '../helpers/localStorage'
import { useSnackbar } from './containers/SnackbarContainer'
import { getApiURLAndClientID, getDefaultEnv, getEnumOptions } from '../helpers/utils'

const style = {
  p: 4,
  boxShadow: 24,
  borderRadius: 1,
  backgroundColor: 'background.paper',
}

function LoginSettingsPopover(): JSX.Element {
  const { t } = useTranslation()
  const { openErrorSnackbar } = useSnackbar()
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)
  const [openModal, setOpenModal] = useState(false)
  const [environment, setEnvironment] = useState<string | null>(() => {
    try {
      return getDefaultEnv()
    } catch (e) {
      return null
    }
  })

  useEffect(() => {
    try {
      getDefaultEnv()
    } catch (e) {
      setOpenModal(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    try {
      setLocalStorage(DEFAULT_ENV_KEY, event.target.value)
      setEnvironment(event.target.value)
      const { apiUrl } = getApiURLAndClientID()
      if (apiUrl) setBaseUrl(apiUrl)
    } catch (e) {
      openErrorSnackbar({}, t('allowCookies'))
    }
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined

  return (
    <>
      <Button aria-describedby={id} sx={{ color: 'text.secondary', textTransform: 'capitalize' }} onClick={handleClick}>
        <Typography>{environment}</Typography>
        <SettingsIcon />
      </Button>
      <Popover
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        anchorEl={anchorEl}
      >
        <Box sx={style}>
          <FormControl component="fieldset">
            <FormLabel component="legend">{t(`environmentSettings`)}</FormLabel>
            <RadioGroup value={environment} name="environment-radio-buttons-group" onChange={handleChange}>
              {getEnumOptions(Environment).map((env, index) =>
                isProduction() && env.value === Environment.staging ? null : (
                  <FormControlLabel key={index} value={env.value} control={<Radio />} label={env.label} />
                )
              )}
            </RadioGroup>
          </FormControl>
        </Box>
      </Popover>
      {/*modal for allow cookies message*/}
      <Modal open={openModal}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            p: 3,
            width: 370,
            bgcolor: 'background.paper',
            boxShadow: 24,
            borderRadius: 1,
          }}
        >
          <Grid container justifyContent="center">
            <Typography variant="h6" color="text.secondary" mb={2}>
              {t('allowCookies')}
            </Typography>
            <Button variant="contained" onClick={() => setOpenModal(false)}>
              {t('ok')}
            </Button>
          </Grid>
        </Box>
      </Modal>
    </>
  )
}
export default LoginSettingsPopover
